function m(i) {
  const t = ["list"];
  return (i.size === "medium" || i.size === void 0) && t.push("list-medium-vertical"), i.padding === "large" && t.push("list-large-horizontal"), i.truncate && t.push("list-truncate"), t.join(" ");
}
function c(i, t, n, o, u, l, e) {
  const s = ["list-item"];
  return !t && (o || n === i.onClick || l && e && l.includes(e)) && s.push("list-item-active"), u && s.push("list-item-focused"), t && t.trim() && s.push("list-item-no-icon"), s.join(" ");
}
const f = Symbol("list"), a = Symbol("split-button-list");
export {
  f as ListSymbol,
  a as SplitButtonListSymbol,
  c as getListItemStyleClasses,
  m as getListStyleClasses
};
